<div class="chart">
  <kendo-chart class = "kendo-chart" *ngIf="!isLoading && chartData.length > 0">
    <kendo-chart-legend [visible]="true" categoryField="region" position="bottom" orientation="vertical">
    </kendo-chart-legend>
    <ng-template kendoChartDonutCenterTemplate>
      <h3>{{totalPushes}} <br>Total Charts <br>Pushed</h3>
    </ng-template>
    <kendo-chart-series>
      <kendo-chart-series-item type="donut" [data]="chartData" [holeSize]="95" categoryField="region" field="share"
        [padding]="20">
        <!-- <kendo-chart-series-item-labels
            position="outsideEnd"
            color="#000"
            [content]="labelContent">
          </kendo-chart-series-item-labels> -->
      </kendo-chart-series-item>
    </kendo-chart-series>
  </kendo-chart>
</div>